'use strict';

angular.module('app.addNewCommonPage', [])
    .controller('addNewCommonPageCtrl', ['$scope', '$modal', '$location', 'commonPagesService', 'addNewCommonPageService',
         function ($scope, $modal, $location, commonPagesService, addNewCommonPageService) {

            commonPagesService.getCommonPagesSetting(false)
                .then(function(response) {
                    $scope.settings = response.data;
                }, function(response) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
                })

            $scope.addNewCommonPage = function () {
                $scope.selectedSetting = "";
                $scope.settings.forEach(function (val) {
                    if (val.ticked === true) {
                        $scope.selectedSetting = val.id;
                    }    
                });

                var params = {
                    subfix: $scope.subfix,
                    setting: $scope.selectedSetting
                }

                addNewCommonPageService.addNewCommonPage(params, true)
                    .then(function(response) {
                        $scope.modalInstance.close(function () {
                            $log.info('Close Modal now');
                        })

                        location.reload('admin/commonPages');
                    }, function(response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

}])